"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppointmentCancellationReasons = exports.cancelAppointmentById = exports.getProviderById = exports.getAppointmentById = void 0;
/**
 * Function to call the `getAppointment` callback, extract the data from it,
 * and return the converted form for use in the state machine.
 * @param {*} getAppointmentCallback Callback to make an API request to get an appointment.
 *                                   Returns the HTTP Response.
 *                                   Appointment data will be nested under `data` in `appointment` and `capabilities`.
 * @param {*} appointmentId The id of the appointment we're requesting.
 * @returns The converted appointment object to be stored in the machine context.
 */
const getAppointmentById = (getAppointmentCallback, appointmentId) => __awaiter(void 0, void 0, void 0, function* () {
    const appointmentResponse = yield getAppointmentCallback(appointmentId);
    return appointmentResponse.data;
});
exports.getAppointmentById = getAppointmentById;
/**
 * Function to call the `getProvider` callback, and return the data from it.
 * @param {*} getProviderCallback Callback to make an API request to get a provider.
 *                                Returns the HTTP Response.
 *                                Provider data should be top level.
 * @param {*} providerId The id of the provider we're requesting.
 * @returns The requested provider
 */
const getProviderById = (getProviderCallback, providerId) => __awaiter(void 0, void 0, void 0, function* () {
    const providerResponse = yield getProviderCallback(providerId);
    const provider = Object.assign(Object.assign({}, providerResponse.data.data.provider), { locations: providerResponse.data.data.locations });
    return provider;
});
exports.getProviderById = getProviderById;
/**
 * Function to call the `cancelAppointment` callback, and return the data from it.
 * @param {*} cancelAppointmentCallback Callback to make an API request to cancel an appointment.
 *                                      Returns the HTTP Response.
 * @param {*} appointmentId The id of the appointment we're canceling.
 * @param {*} cancelEmail The email to send the cancel confirmation to
 * @param {*} cancelEmailConsent Boolean representing consent to receive an email.
 * @param {*} cancelReasonText Optional text reason why appointment is being canceled.
 */
const cancelAppointmentById = (cancelAppointmentCallback, appointmentId, cancelEmailConsent, cancelReasonText) => __awaiter(void 0, void 0, void 0, function* () {
    yield cancelAppointmentCallback(appointmentId, cancelEmailConsent, cancelReasonText);
});
exports.cancelAppointmentById = cancelAppointmentById;
const getAppointmentCancellationReasons = (getAppointmentCancellationReasonsCallback, sourceSystem) => __awaiter(void 0, void 0, void 0, function* () {
    if (!getAppointmentCancellationReasonsCallback || !sourceSystem) {
        throw new Error('Failed fetching cancellation reasons. Missing callback or source system');
    }
    const cancellationReasonsResponse = yield getAppointmentCancellationReasonsCallback(sourceSystem);
    if (!cancellationReasonsResponse.data)
        throw new Error('No cancellation reasons found');
    return cancellationReasonsResponse.data.result;
});
exports.getAppointmentCancellationReasons = getAppointmentCancellationReasons;
//# sourceMappingURL=API.js.map